import ackCallTransfer from '@/components/AckCallTransferRequest/AckCallTransferRequest.i18n.pt';
import whatsAppSessionVoiceStatus from '@/components/content-attendance/WhatsAppSessionVoiceStatus/WhatsAppSessionVoiceStatus.i18n.pt';
import whatsAppVoiceDialog from '@/components/content-attendance/header-attendance/widgets/WhatsAppVoiceDialog/WhatsAppVoiceDialog.i18n.pt';
export default {
  ...ackCallTransfer,
  ...whatsAppSessionVoiceStatus,
  ...whatsAppVoiceDialog,
  connectionErrorChannel: {
    chat: {
      auth: 'Você não está autorizado a se conectar no canal de chat',
      online: 'Você já está conectado no canal de chat',
      limit:
        'Não pode se conectar pois ultrapassou o limite de conexões de chat',
      queue:
        'Não é possível se conectar pois o agente não pertence a nenhum grupo de atendimento de Chat',
      chatserver_offline: 'O serviço de chat não está disponível no momento',
    },
  },
  tags: 'Tags',
  attendanceFields: 'Campos do atendimento',
  attendanceObservation: 'Observação do atendimento',
  limitGlobal: 'Atingido limite de atendimentos para o canal',
  typing: 'Digitando...',
  invalidDateFormat: 'Formato de data inválido',
  invalidCpfCnpjFormat: 'Formato CPF/CNPJ Inválido',
  contactNotRegistered: 'Contato não cadastrado',
  chatVisor: {
    label: 'ChatVisor',
    supervisors: 'Supervisores',
    startChat: 'Iniciar conversa',
    search: 'Buscar',
    notSupervisorsOnline: 'Não há supervisores online no momento!',
    errConnect: 'Ocorreu um erro ao se conectar no ChatVisor',
    newMessageChatVisor: 'Uma nova mensagem foi recebida!',
  },
  channelLabel: 'Canal',
  channel: {
    voice: 'Voz',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
  },
  errUploadFile: 'Ocorreu um erro no envio do arquivo, tente novamente!',
  findQualification: 'Qualificação desejada',
  findJob: 'Buscar atendimento',
  hangUpCall: {
    cardTitle: 'Desligar Chamada',
    cardText: 'Você está prestes a desligar essa chamada.',
    tooltip: 'Desligar chamada!',
    cancel: '',
    confirmation: 'Desligar',
  },
  duplicate: 'Campo duplicado',
  types_alert: {
    error: 'Erro',
    err: 'Erro',
    warning: 'Alerta',
    success: 'Sucesso',
    notification: 'Notificação',
    chatVisor: 'ChatVisor',
    newWhatsAppEvent: 'Novo Atendimento WhatsApp',
    newInstagramEvent: 'Novo Atendimento Instagram',
    callDeclined: 'Chamada recusada',
    callLost: 'Chamada perdida',
    callAccepted: 'Chamada aceita',
    callReceived: 'Chamada recebida',
  },
  scriptFieldsRequired: 'Esse campo é obrigatório!',
  required: 'Esse campo é obrigatório',
  notAuthorized: 'Usuário ou senha inválidos',
  userNotFound: 'Usuário ou senha inválidos',
  alreadyConnected: 'Usuário já está conectado',
  loginAccepted: 'Login realizado com sucesso',
  online: 'Online',
  inactive: 'Ausente',
  ok: 'OK',
  rowsPerPage: 'Linhas por página',
  login: 'Acessar',
  loginError: 'Não foi possível realizar login',
  lostConnection: 'Você perdeu a conexão com o servidor',
  logoffError: 'Não foi possível se desconectar do sistema',
  description: 'descrição',
  unknown: 'Erro desconhecido ao realizar a ação',
  pauseSuccess: 'Pausa acionada com sucesso',
  pauseError: 'Não é possível colocar em pausa neste momento',
  unpauseError:
    'Não foi possível retirar a pausa no momento. Tente novamente mais tarde!',
  searchContact: 'Buscar contato',
  columnsNotFound: 'Colunas não encontradas',
  selectTheme: 'Selecione um tema',
  select: 'Selecionar',
  selectPhone: 'Selecione ou digite o número desejado',
  transferAttendance: 'Transferir atendimento',
  name: 'nome',
  actions: 'Ações',
  noDataAvailable: 'Nenhum registro encontrado',
  noSchedulesAvailable: 'nenhum agendamento encontrado',
  date: 'data',
  search: 'pesquisar',
  id: 'id',
  phone: 'Telefone',
  whatsApp: 'whatsApp',
  identifier: 'identificador',
  goBack: 'voltar',
  editing: 'Editando',
  addTagToAttendance: 'Adicione uma tag ao atendimento',
  errorGetContact: 'Erro ao recuperar dados do contato',
  pauseAgended:
    'A pausa foi agendada e entrará assim que finalizar seus atendimentos',
  leavePauseAgended:
    'Removido agendamento da pausa {pauseName} do {channelName}',
  inWhatsappAttendance:
    'Não é possível se desconectar porque você está em atendimento',
  notAllowWhatsapp: 'Você não possui permissão para logar em WhatsApp',
  notAllowLoginBecauseAlreadyOnlineWhatsApp:
    'Não é possível se conectar pois o agente já está online em WhatsApp',
  notAllowLoginBecauseLimitWhatsApp:
    'Não é possível se conectar pois ultrapassou o limite de conexões de WhatsApp',
  notAllowLoginBecauseAlreadyOfflineWhatsApp:
    'Não é possível se desconectar pois o agente já está desconectando',
  notAllowLoginBecauseQueueWhatsApp:
    'Não é possível se conectar pois o agente não pertence a nenhum grupo de atendimento de WhatsApp',
  allowWhatsApp: 'Você está agora logado em WhatsApp',
  'disconnectChannel-whatsapp': 'Desconnectado do WhatsApp',
  errorDisconnectChannel:
    'Não foi possível se desconectar , tente novamente mais tarde!',
  'errorDisconnectChannel-whatsapp':
    'Não foi possível se desconectar de Whatsapp',
  fieldsRequired: 'Preencha os campos obrigatórios!',
  errorConnectChannel:
    'Ocorreu um erro ao tentar se connectar ao canal, tente novamente mais tarde!',
  newJob: 'Você recebeu um novo atendimento',
  newWhatsappJob: 'Você recebeu um novo atendimento de Whatsapp',
  newInstagramJob: 'Você recebeu um novo atendimento de Instagram',
  newVoiceJob: 'Você recebeu um novo atendimento de Voz',
  newChatJob: 'Você recebeu um novo atendimento de Chat',
  cannotActiveJobBecauseInPause:
    'Não é possível iniciar o atendimento ativo porque o atendente está em pausa',
  cannotTransferBecauseAgentOffline:
    'Não foi possível transferir porque o agente de destino está offline',
  cannotTransferBecauseAgentNotInQueue:
    'Não foi possível transferir porque o destino não pertence ao mesmo grupo de atendimento',
  cannotTransferBecauseAgentInPause:
    'Não foi possível transferir porque o agente de destino está em pausa',
  cannotTransferUnknownError:
    'Não foi possível transferir. Ocorreu um erro desconhecido.',
  welcomeToWeon: 'Seja bem-vindo ao WeON',
  fieldRequired: 'Esse campo é obrigatório',
  loginSuccess: 'Login realizado com sucesso',
  Logout: 'Logout',
  enterPause: 'Acionar pausa',
  leavePause: 'Remover pausa',
  WhatsApp: 'WhatsApp',
  whatsappText: {
    connectIn: 'Conectar em whatsapp',
    disconnectIn: 'Desconectar de whatsapp',
  },
  voiceText: {
    connectIn: 'Conectar em voz',
    disconnectIn: 'Desconectar de voz',
    addToCall: 'Adicionar à ligação',
    pressNewNumber:
      'Digite o número telefônico do novo participante da conferência',
    phone: 'Telefone',
    add: 'Adicionar',
    finishConf: 'Encerrar conferência',
    removeSecondPerson: 'Deseja remover a segunda pessoa da ligação?',
    cancel: 'Cancelar',
    finish: 'ENCERRAR',
  },
  queue: 'Fila',
  attendanceGroupTransfer: 'Grupo de atendimento',
  exit: 'Sair',
  noQuickMessagesRegistered: 'Nenhuma mensagem rápida cadastrada',
  quickMessages: 'Mensagens rápidas',
  transferenceAttendance: 'Transferência de atendimento',
  transferenceAttendanceIncoming:
    'Você está recebendo uma transferência de atendimento',
  transferIncoming:
    'O agente {agentName} está transferindo um atendimento para você',
  agent: 'Agente',
  bot: 'Bot',
  selectAnBot: 'Selecione um bot',
  selectAnAgent: 'Selecione um agente',
  selectAGroup: 'Selecione um grupo de atendimento',
  selectAQueue: 'Selecione um grupo de atendimento',
  selectThePause: 'Selecione a pausa',
  transfer: 'Transferir',
  connect: 'Conectar',
  disconnect: 'Desconectar',
  attendances: 'Atendimentos',
  attendance: 'Atendimentos',
  messages: 'Mensagens',
  choiceYourEmoji: 'Escolha o seu emoji',
  send: 'Enviar',
  sendAttachments: 'Enviar arquivos',
  cardActions: {
    recorderAudioMessage: 'Gravar mensagem de áudio',
  },
  cancel: 'Cancelar',
  effect: 'Efetuar',
  enter: 'Acionar',
  qualify: 'Qualificar',
  qualifyAttendance: 'Qualificar atendimento',
  qualificationSuccess: 'Qualificação realizada com sucesso',
  contactInBlacklist:
    'Desculpe, mas esse contato está bloqueado e não pode ser acionado.',
  edit: 'Editar',
  editContact: 'Editar contato',
  finishAttendance: 'Finalizar Atendimento',
  finish: 'Finalizar',
  presetMessages: 'Mensagens rápidas',
  message: 'Mensagem',
  selectMessage: 'Selecione uma mensagem',
  waitingAttendance: 'Aguardando atendimento',
  selectedMessage: 'Mensagem selecionada',
  weonPlugs: 'WeON Plugs',
  channelActions: 'Ações do canal',
  attendanceChannels: 'Canais de atendimento',
  'loggedInChannel-whatsapp': 'Você está agora logado em WhatsApp',
  enterPauseInAllChannels: 'Acionar pausa em todos os canais de atendimento',
  enterPauseIn: 'Acionar pausa em',
  leavePauseSuccess: 'Pausa removida com sucesso',
  notRegistered: 'Não cadastrado',
  addContactSuccess: 'Contato adicionado com sucesso',
  addContactError: 'Houve um erro ao adicionar o contato',
  editContactSuccess: 'Contato editado com sucesso',
  historyOfAttendances: 'Histórico de Atendimentos',
  history: 'histórico',
  messageLogoff: 'Você está saindo do sistema, deseja mesmo continuar?',
  agentWhatsappOffline: 'Você não está conectado em WhatsApp',
  noMessagesForThisJob: 'Nenhuma mensagem para esse atendimento',
  configurations: 'Configurações',
  pause: 'pausa',
  confirm: 'Confirmar',
  warning: 'Atenção',
  scriptNotFound:
    'Não existe nenhum Script cadastrado para esse grupo de atendimento!',
  script: 'Script',
  add: 'Adicionar',
  addContact: 'Adicionar contato',
  save: 'Salvar',
  voice: 'Voz',
  whatsapp: 'whatsApp',
  chat: 'chat',
  channelChat: {
    logged: 'Você está agora logado em Chat',
    errorConnect:
      'Ocorreu um erro ao tentar se connectar ao canal de Chat, tente novamente mais tarde!',
    errorDisconnect:
      'Ocorreu um erro ao se deconectar do Chat, tente novamente mais tarde',
    logoff: 'Desconectado de Chat',
  },
  confirmEndWhatsApp:
    'Você tem certeza que deseja finalizar o atendimento de WhatsApp',
  confirmDisconnect: 'Você tem certeza que deseja se desconectar',
  confirmDisconnectWhatsapp:
    'Você tem certeza que deseja se desconectar do canal de WhatsApp',
  confirmDisconnectVoice:
    'Você tem certeza que deseja se desconectar do canal de Voz',
  confirmDisconnectChat:
    'Você tem certeza que deseja se desconectar do canal de Chat',
  triggerContact: 'Acionar contato',
  campaign: 'Campanha',
  triggerContactByWhatsApp: 'Acionar contato por WhatsApp',
  triggerContactByVoice: 'acionar contato por voz',
  triggerActiveJobSuccess: 'O atendimento para o contato será iniciado',
  triggerActiveJobError: 'Erro ao iniciar atendimento para o contato',
  selectCampaign: 'Selecione a campanha',
  selectAttendanceGroup: 'Selecione o grupo de atendimento',
  attendanceNotFound: 'Atendimento não encontrado',
  exception: 'Houve um erro ao realizar o processo',
  emoticons: {
    search: 'Pesquisa',
    notfound: 'Nenhum Emoticon encontrado',
    categories: {
      search: 'Pesquisar',
      recent: 'Usados frequentemente',
      people: 'Smileys & Pessoas',
      nature: 'Animais e natureza',
      foods: 'Comidas e Bebidas',
      activity: 'Atividade',
      places: 'Viagem e Lugares',
      objects: 'Objetos',
      symbols: 'Simbolos',
      flags: 'Bandeiras',
      custom: 'Customizado',
    },
  },
  limitQueue:
    'Máximo de atendimentos simultâneos para o grupo de atendimento atingido',
  noData: 'Não há dados disponíveis',
  protocol: 'Protocolo',
  notifications: 'Notificações',
  lastWeek: '1 semana',
  today: 'Hoje',
  week: 'Semana',
  month: 'Mês',
  lastMonth: '1 mês',
  interval: 'Intervalo',
  titleModalInterval: 'Selecione o Intervalo',
  'Must be a digit': 'Tem que ser o chaves',
  'Invalid email': 'Email inválido',
  exten: 'Ramal',
  messageExtenConnectVoiceChannel:
    'É necessário informar um ramal para a conexão no canal de voz.',
  exten_not_exist: 'Ramal não existe',
  dialNow: 'discar agora',
  dialer: 'discador',
  scheduleToSameNumber: 'agendar para o mesmo número',
  sameNumber: 'mesmo número',
  yes: 'sim',
  no: 'não',
  delete: 'excluir',
  next: 'próximo',
  previous: 'anterior',
  createScheduling: 'criar agendamento',
  createSchedulingToContact: 'Criar agendamento',
  editSchedulingToContact: 'editar agendamento para o contato',
  deleteSchedulingContact: 'excluir agendamento do contato',
  scheduleToTitle: 'Encaminhar atendimento',
  scheduleToMe: 'Para mim',
  scheduleToCampaign: 'Para um grupo',
  scheduleCampaign: 'Chamar via',
  phoneNumber: 'número de telefone',
  dateScheduling: 'data do agendamento',
  hourScheduling: 'hora do agendamento',
  schedulingCreatedSuccess: 'agendamento criado com sucesso',
  schedulingUpdatedSuccess: 'agendamento atualizado com sucesso',
  schedulingDeletedSuccess: 'agendamento excluído com sucesso',
  errorOnDeleteScheduling: 'erro ao deletar agendamento',
  schedules: 'agendamentos',
  schedule: 'agendar',
  noSchedulingForThisContact: 'nenhum agendamento para este contato',
  schedulingWithoutDate: 'agendamento sem data',
  withoutDate: 'Sem data',
  preferential: 'preferencial',
  notPreferential: 'não preferencial',
  createdAt: 'criado em',
  byAgent: 'pelo agente',
  createdBy: 'criado por',
  transfers: 'Transferências',
  to: 'para',
  from: 'de',
  contactInformations: 'Informações do contato',
  invalidInformationsToCreateScheduling:
    'informações inválidas para criar o agendamento',
  invalidInformationsToSaveContact:
    'informações inválidas para salvar o contato',
  hourOutOfCalendarDialer:
    'Horário do agendamento fora do calendário do discador',
  confirmDeleteScheduling: 'tem certeza de que deseja excluir esse agendamento',
  voiceChannel: {
    'loggedInChannel-voice': 'Você está agora logado em Voz',
    auth: 'Não pode se conectar pois o agente não está autorizado a se logar em Voz!',
    online: 'Não pode se conectar pois o agente já está online em Voz!',
    offline: 'Offline',
    limit: 'Não pode se conectar pois ultrapassou o limite de conexões de Voz!',
    queue:
      'Não é possível se conectar pois o agente não pertence a nenhum grupo de atendimento de Voz',
    exten_register: 'Ramal não registrado',
    'errorDisconnectChannel-voice': 'Não foi possível se desconectar de Voz',
    exten_not_exist: 'Ramal não existe',
    'disconnectChannel-voice': 'Desconectado de Voz',
    extenRegister: 'Ramal não registrado',
    extenNotExist: 'Ramal não existe',
    extenInUse: 'O ramal solicitado já está sendo utilizado',
    originate: 'Não foi possível chamar esse ramal',
  },
  error: 'Ocorreu um erro, tente novamente mais tarde',
  whatDoYouWantToDo: 'O que você deseja fazer',
  linkWithThisField: 'Relacionar o contato à partir deste campo',
  dataLinkedWithContactSuccess: 'Dado vinculado ao contato com sucesso',
  noDataTextAgent: 'Nenhum agente disponível no momento',
  noDataTextAgentTransfer: 'Nenhum agente disponível para transferir',
  noDataTextQueue: 'Nenhum grupo de atendimento disponível no momento',
  noDataTextBot: 'Nenhum Bot disponível no momento',
  searchContactAndLinkWithThisJob:
    'Procurar um contato e relacionar com o cliente deste atendimento',
  linkToContact: 'vincular à contato',
  vinculate: 'Vincular',
  changePause: 'Trocar pausa',
  removePause: 'Remover pausa',
  registerNew: 'cadastrar novo',
  registerContactForThisJob:
    'cadastrar um contato para o cliente deste atendimento',
  noDialersAvailableToCreateScheduling:
    'não há discadores disponíveis para criar um agendamento',
  problemWithDialer: 'O discador não conseguiu agendar este contato',
  qualificationSelected: 'qualificação selecionada',
  qualificationCode: 'código da qualificação',
  qualificationNotFound: 'Qualificação não encontrada',
  noJobDataFoundByPeriod:
    'Nenhum atendimento encontrado para o período selecionado',
  selectDateRange: 'Selecione um período',
  hangupVoiceCallFailure: 'A chamada não pôde ser completada, tente novamente',
  hangupVoiceCallClient: 'A chamada foi desligada pelo cliente',
  hangupVoiceCallAgent: 'Chamada com o cliente finalizada',
  confirmEndVoice:
    'Você tem certeza que deseja finalizar o atendimento de Voz?',
  confirmEndChat:
    'Você tem certeza que deseja finalizar o atendimento de Chat?',
  expired: 'Expirados',
  pauseErrorInThisMoment: 'Não é possível colocar em pausa neste momento',
  processingScheduling: 'Processando agendamento',
  areYouThere: 'Você está ai {agentName}?',
  dialingToContact: 'Discando para o contato',
  dialerWorkingToDeliveryCall:
    'O discador está trabalhando para lhe entregar uma chamada',
  dialstatus: 'Status da Discagem',
  ANSWER: 'Atendido',
  MACHINE: 'Máquina',
  BUSY: 'Ocupado',
  NOANSWER: 'Não atendida',
  NOROUTE: 'Sem Rota',
  CONGESTION: 'Falha',
  FAILED: 'Falha',
  DISCARD: 'Descartado',
  dialed: 'Disacada',
  youAreNotConnectedInWhatsapp: 'Você não está conectado em whatsapp',
  youAreNotConnectedInVoice: 'Você não está conectado em voz',
  cannotCreateSchedulePastDate:
    'Você não pode criar um agendamento para uma data passada',
  cannotCallToContact: 'Não foi possível discar para o contato',
  cannotCreateScheduleInvalidHour:
    'Você inseriu um horário inválido. Horas devem estar entre 00 e 23, e minutos entre 00 e 59.',
  agentWithoutVoiceCampaign: 'Você não faz parte de nenhuma campanha de voz',
  agentWithoutWhatsAppCampaign:
    'Você não faz parte de nenhuma campanha de whatsapp',
  searchContactFieldRequired:
    'Campo de pesquisa de contato não pode ser vazio.',
  N: 'Não',
  Y: 'Sim',
  selectOrAddPhone: 'Selecione ou adicione um número',
  digitNumberAndPressEnter: 'Digite o número e pressione Enter',
  fastJobInWhatsapp: 'Acionamento rápido em whatsapp',
  fastJobInVoice: 'Acionamento rápido em voz',
  fastJobByWhatsapp: 'Acionamento rápido de whatsapp',
  fastJobByVoice: 'Acionamento rápido de voz',
  whatsappNumber: 'Número de whatsapp',
  minLengthCaracters: 'Deve ter pelo menos {num} caracteres',
  notConnectedInWhatsapp: 'Você não está connectado em Whatsapp',
  notConnectedInVoice: 'Você não está connectado em Voz',
  forOneNumber: 'Para um número',
  digitNumber: 'Digite um número',
  changeContact: 'Alterar contato',
  transferError: {
    undefined: 'Não foi possível transferir. Sistema não disponível.',
    cannotTransferUnknownError:
      'Não foi possível transferir. Sistema não disponível. ',
    agentNotLinked:
      'Não é possível transferir, pois a chamada já foi encerrada.',
    offline: 'Não foi possível realizar a transferência',
    agentOffline: 'O agente selecionado está offline',
    agentPaused: 'O agente selecionado está em pausa',
    agentInCall: 'O agente selecionado está em outra chamada',
    agentInTransfer: 'O agente já está em processo de transferência',
    exception: 'Houve um problema na transferência, por favor tente novamente.',
    pause: 'Agente em pausa',
    default: 'Houve um problema na transferência, por favor tente novamente.',
    error: 'Houve um problema na transferência, por favor tente novamente.',
    assistedTransferQueue:
      'Não é possível realizar transferência assistida para um grupo de atendimento',
    transferAgent:
      'Para realizar uma transferência para um agente, selecionar a opção Agente',
    agentExten:
      'Não é possível realizar transferência para um ramal utilizado por um Agente',
    queueAgentsUnavailable: 'Não foi encontrado nenhum agente disponível.',
    invalid_queue: 'Não foi possível encontrar o grupo de atendimento.',
    transfer_agent_number: 'Não foi possível transferir para o atendente.',
  },
  disconnectedBySystem: 'Desconectado pelo sistema',
  endChatByClient: 'Chat finalizado pelo cliente',
  client: 'Cliente',
  agentInCall: 'O agente já está com uma chamada ativa',
  AgentInCall: 'O agente já está com uma chamada ativa',
  ClientInCall: 'Este cliente já possui uma chamada ativa',
  clientInCall: 'Este cliente já possui uma chamada ativa',
  informations: 'Informações',
  contactAlreadyExists:
    'Já existe um contato cadastrado com esse identificador',
  registerContactBeforeQualify: 'Cadastre o contato antes de qualificar',
  registerContactBeforeTransfer: 'Cadastre o contato antes de transferir',
  channelStatistics: 'Estatísticas dos Canais',
  calledContacts: 'Contatos Realizados',
  scheduleContacts: 'Contatos Agendados',
  observation: 'Obs.',
  placeholderObservation: 'Digite seu texto para observações aqui...',
  conversation: 'Conversas',
  record: 'Gravação',
  jobCopiedToClipboard: 'Atendimento copiado para a àrea de transferência',
  copyJobMessages: 'Copiar mensagens do atendimento',
  completedJobs: 'Atendimentos realizados',
  madeSchedules: 'Agendamentos realizados',
  qualifyAttendanceProtocol: 'Qualificando atendimento ',
  notDialed: 'Não discado',
  accumulatedTimesToday: 'Tempo conectado hoje',
  choiceAvatar: 'Escolha um avatar',
  logoff: {
    attendance: 'Você possui atendimentos ativos',
    auth: 'Você possui atendimentos ativos',
    offline: 'O serviço de Voz está fora do ar',
    logoffError: 'Não foi possível se desconectar do sistema',
  },
  weFoundContactSameIdentifier:
    'Encontramos um contato com este mesmo identificador',
  thisContactAlreadyRegistered: 'Esse contato já está cadastrado',
  thisContactIdentifierHasWhiteSpace:
    'Identificador do contato não pode conter espaço',
  continue: 'continuar',
  errorLoadMoreMessages: 'Opps, não foi possível recuperar as mensagens :( ',
  noMoreMessages: 'Não há mais mensagens',
  redial: 'Rediscar',
  callAgainToContact: 'Discando novamente para o contato',
  wait: 'Aguarde',
  reopen: 'Reabrir',
  thisJobWillReopen: 'Este atendimento será aberto novamente',
  noInboxJobs: 'Nenhum atendimento em aberto',
  jobsOpen: 'Atendimentos em aberto',
  alreadyInAttendance:
    'Este cliente já está sendo atendido pelo agente {agentName}',
  alreadyInInbox: 'Este cliente está retido com o agente {agentName}',
  clientOnHold:
    'Este cliente está na posição {queuePosition} para ser atendido no grupo {queueName}',
  clientOnHoldPreferential:
    'Não é possível acionar o contato, pois está registrado na carteira do {agentName}',
  clientOnBot: 'Este cliente está sendo atendido pelo bot',
  agentNotInCampaign:
    'Este atendimento não pode ser iniciado. Você não faz parte do grupo selecionado. Por favor, selecione um outro grupo ou entre em contato com o suporte da WeON para resolver este problema.',
  tooltip: {
    tipDashboard: 'Dashboard de atendimento',
    tipChatvisor: 'Conversa com os supervisores',
    tipProtocolAttendance: 'Protocolo de atendimento',
    tipGroupAttendance: 'Grupo de atendimento',
    tipCampaignAttendance: 'Campanha de atendimento',
    tipChannelAttendance: 'Canal de atendimento e identificador',
    tipInitialTimeAttendance: 'Horário de início do atendimento',
    tipPhoneIdentifier: 'Telefone',
    tipInbox: 'Atendimentos em aberto',
    tipNotifications: 'Central de Notificações',
    tipPreferentialContacts: 'Carteira',
  },
  initalDateIsGreaterThanFinalDate: 'Data inicial é maior que a data final',
  intervalISBiggerThen3Months: 'Intervalo é maior que 3 messes',
  initalDateIsBiggerNow: 'Data inicial é maior que data atual',
  invalidDate: 'Data inválida',
  thisMessageCouldNotBeSent: 'Não foi possível enviar esta mensagem',
  more: 'Mais',
  you: 'Você',
  unsuportedBrowser: 'Navegador não suportado',
  messageUnsuportedBrowser:
    'Você está utilizando uma versão antiga do navegador ou está utilizando um navegador que não é suportado pelo sistema',
  downloadMostRecentBrowser:
    'Você precisará da versão mais recente de um dos navegadores abaixo',
  firefox: 'Firefox',
  chrome: 'Chrome',
  opera: 'Opera',
  anotherSessionActive: 'Outra sessão do atendente foi iniciada em outra aba',
  messageTabDisabled:
    'A aplicação de Atendente está aberta em outro computador ou navegador/aba. Então, você não pode utilizar esta janela',
  contactVinculatedToActiveJob:
    'O contato {name} foi vinculado ao atendimento ativo',
  allColumnsWithValues:
    'Todas as colunas deste contato estão preenchidas e não é possível vincular o dado ao contato.',
  form: 'Formulário',
  journey: 'Jornada',
  filter: 'Filtro',
  cannotCopyBecauseMessagesEmpty:
    'Este atendimento não possui nenhuma mensagem trocada para copiar',
  moreContactFound: 'Mais de um contato encontrado para',
  selected: 'Selecionado',
  hasMultiplesContacts: {
    label: 'Atenção!',
    legend: 'Mais de um contato encontrado',
    messageConfirmation:
      'Você está selecionando "{contactName}" para o atendimento! Deseja mesmo continuar?',
  },
  dashboard: {
    tabDashboard: 'Dashboard',
    tabHistory: 'Histórico',
    tabSchedule: 'Agendamento',
    tabPreferential: 'Carteira',
    tabBroadcastList: 'Transmissões',
  },
  preferentialClients: 'Clientes preferenciais',
  dateLastAttendance: 'Data do último contato',
  avatar: 'Avatar',
  goToLogin: 'Ir para o Login',
  lostConnectWithServer: 'A conexão com o servidor foi perdida',
  tryingReconnect: 'Tentando reconectar',
  theNumberDoesNotHaveWhatsapp: 'O número {number} não possui um whatsapp',
  unproductiveContact: 'Contato improdutivo',
  confirmUnproductiveContact:
    'Você tem certeza de que deseja marcar este contato como improdutivo?',
  unproductiveContactVoiceNotAvailable:
    'Você precisa finalizar o atendimento de voz para cadastrar o contato como improdutivo.',
  registerContact: 'Cadastrar contato',
  jobFinished: 'Atendimento finalizado',
  close: 'Encerrar',
  initalDateIsBiggerThenFinalDate: 'A data inicial é maior do que a data final',
  transferBlind: 'Cega',
  transferViewed: 'Assistida',
  transferAssisted: 'Transferência assistida',
  configCampaignDefault: 'Campanha Padrão',
  configAttendanceGroupDefault: 'Grupo de Atendimento Padrão',
  campaignVoiceDefault: 'Voz',
  campaignWhatsappDefault: 'Whatsapp',
  alreadyPreferential:
    'Esse contato está cadastrado na carteira do agente {agentName}.',
  pauseAlert: 'Alerta de Pausa',
  pauseExpired: 'O tempo da pausa xxxxxx foi atingido! Deseja remover a pausa?',
  notificationCenter: 'Central de Notificações',
  emptyNotification: 'Sem notificações ;)',
  inboxAttendance: 'Atendimentos INBOX',
  activeWhatsappRequestInProgress:
    'Já existe uma solicitação de WhatsApp em andamento para este número',
  editContactError: 'Id Contato já existe',
  fillNumberToTransferError:
    'O número precisa conter no mínimo 8 e no máximo 15 números.',
  attendanceGroup: 'Grupo de atendimento.',
  attendanceGroupDestination: 'Grupo de atendimento de destino',
  selectAnAttendanceGroup: 'Selecione um grupo de atendimento.',
  jobNotFound: 'Nenhum resultado encontrado',
  jobsNotAvailable: 'Nenhum atendimento acontecendo agora',
  inboxJobsTitle: 'Retidos',
  inboxJobsNotAvailable: 'Nenhum atendimento retido',
  noRouteFound:
    'O grupo de atendimento utilizado não está configurado com uma rota.',
  errorFastJob: 'Houve uma falha ao inicar o atendimento.',
  whatsAppSessionExpired: 'Janela expirada',
  whatsAppSessionActive: 'Janela ativa',
  whatsAppSessionActiveTooltip:
    'Este cliente interagiu com a empresa nas últimas 24h. Você pode conversar com ele através de texto livre ou utilizar um template',
  whatsAppSessionExpiredTooltip:
    'Este cliente não interagiu com a empresa nas últimas 24h. É necessário utilizar um template para iniciar uma conversa',
  whatsAppTemplateHeaderStartConversation: 'Iniciar conversa com template',
  whatsAppTemplateHeaderReadOnly: 'Você está em modo de visualização',
  whatsAppTemplateShowConversationButton: 'Ver conversa',
  whatsAppTemplateShowTemplatesButton: 'Ver templates',
  whatsAppTemplateSendButton: 'Usar',
  whatsappPhoneWrongPattern:
    'O telefone precisa ter no mínimo 12 dígitos para ser acionado.',
  evaluation:
    'Aguardando avaliação de atendimento do cliente. Tente novamente mais tarde.',
  whatsAppSessionInformation: {
    waitingResponse: {
      title:
        'Template enviado com sucesso! Estamos aguardando a resposta do cliente para abrir a janela de conversa.',
      subtitle:
        'Evite enviar muitos templates sem retorno, o WhatsApp pode limitar o envio.',
    },
    startWithTemplate: {
      title: 'É necessário iniciar a conversa a partir de um template',
      subtitle:
        'Sua janela de 24 horas para envio de mensagens está expirada. Para iniciar um novo atendimento, é necessário enviar um template e aguardar a resposta do contato.',
      button: 'Ver templates',
    },
    expired: {
      title: 'Sua janela de conversa com o contato expirou',
      subtitle:
        'Sua janela de 24 horas para envio de mensagens está expirada. Para continuar o atendimento, é necessário enviar um template e aguardar a resposta do contato.',
      button: 'Ver templates',
    },
  },
  instagramSessionInformation: {
    expired: {
      title: 'Sua janela de conversa com o contato expirou',
      subtitle: 'Sua janela de 24 horas para envio de mensagens está expirada.',
      information:
        'No canal de Instagram, não é possível acionar o contato através de templates. Para continuar o atendimento, o contato deve enviar uma mensagem para você.',
    },
  },
  broadcast: {
    empty: {
      title: 'Você não realizou nenhuma transmissão',
      altImage: 'Lista de transmissão vazia',
      createNewBroadcastButton: 'Criar transmissão',
    },
    add: {
      title: 'Nova transmissão',
      nameInputLabel: 'Nova lista de transmissão',
      toInputLabel: 'Para',
      toInputNoData: 'Nenhum contato encontrado.',
      attendanceGroupInput: 'Grupo de atendimento',
      attendanceGroupNoData: 'Nenhum grupo encontrado.',
      messageLabel: 'Mensagem',
      changeButton: 'Alterar',
      chooseTemplate: 'Escolher template',
      sendButton: 'Enviar',
      cancelButton: 'Cancelar',
      validation: {
        nameInputMinLength:
          'Nome da lista deve ser maior que {minLength} caracteres.',
        nameInputMaxLength:
          'Nome da lista ultrapassou o limite de {maxLength} caracteres.',
        nameInputRequired: 'Nome da lista é obrigatório',
        contactsSelectedMinLength:
          'É necessário selecionar pelo menos {minLength} contato.',
        contactsSelectedMaxLength:
          'Número máximo de contatos atingido. {maxLength}/{maxLength}',
        contactsSelectedRequired:
          'É necessário selecionar pelo menos {minLength} contato.',
        attendanceWhatsAppGroupSelectedIntegerRequired:
          'Grupo de atendimento é obrigatório',
        attendanceWhatsAppGroupSelectedInteger:
          'Id do grupo deve ser numérico.',
      },
    },
    contacts: {
      title: 'Destinatários de {broadcastName}',
      status: {
        queued: 'Envio agendado',
        sending: 'Enviando...',
        sent: 'Enviado',
        delivered: 'Entregue',
        answered: 'Respondido',
        read: 'Lido',
        errorAlreadyInAttendance: 'Contato já está em atendimento.',
        errorWhatsappIdentifierNotFound:
          'Número de whatsapp não encontrado. Cadastre um número para o contato.',
        errorLimitReached: 'Limite de envios diário atingido.',
        errorFailed: 'Falha ao enviar mensagem.',
        errorPrefixMissing:
          'Problema no número do contato. Adicionar ou remover 9 do número do contato.',
        errorMismatch: 'Enviado. (Possível problema com o número do contato)',
        errorAlreadyInInbox: 'Contato retido.',
        errorClientWindowExpired: 'Janela de atendimento expirada.',
        errorDisconnectedWhatsappNumberOnBroker: 'Número desconectado.',
        errorInactiveSessionNotOptedIn: 'Sessão inativa - não optou.',
        errorInactiveSessionNotOptedInAndTemplateDidNotMatch:
          'Correspondência do template.',
        errorInactiveSessionTemplateDisabled: 'Template desabilitado.',
        errorInactiveSessionTemplateDidNotMatch: 'Template não corresponde.',
        errorInvalidMediaSize: 'Tamanho de mídia inválido.',
        errorInvalidTemplateParams: 'Parâmetros de template inválidos.',
        errorInvalidUrl: 'URL de mídia inválida.',
        errorMessageUndeliverable: 'Mensagem não pode ser entregue.',
        errorMetaWillNotDeliveryMessage: 'Não entregue pela Meta.',
        errorNoTemplateMatch: 'Template não encontrado.',
        errorNotOptedInAndInactive: 'Não optou e inativo.',
        errorPhoneNumberExperiment: 'Número em experimento pela Meta.',
        errorRejectedPrefixMissing: 'Não encontrado.',
        errorTemplate: 'Template ausente.',
        errorUnableToSendCheckWallet: 'Sem saldo.',
      },
    },
    template: {
      title: 'Seleção de template',
      titleUnofficial: 'Mensagem',
    },
    new: {
      toastSuccess: 'Transmissão iniciada com sucesso.',
      toastError: 'Houve um erro na criação da lista de transmissão.',
    },
    cancel: {
      title: 'Cancelar transmissão',
      message: 'Você tem certeza que deseja cancelar a transmissão ',
      returnButton: 'Voltar',
      confirmButton: 'Cancelar transmissão',
      toastSuccess: 'Lista de transmissão cancelada com sucesso.',
      toastError: '',
    },
    management: {
      cancelBroadcastMenu: 'Cancelar transmissão',
      table: {
        notFound: 'Nenhum resultado encontrado.',
        headerBroadcastTitle: 'Nome da transmissão',
        headerSentAmountTitle: 'Enviados',
        headerBroadcastContactsTitle: 'Destinatários',
        headerDateTitle: 'Data',
        contactAmount: '{amount} contato',
        contactAmountPlural: '{amount} contatos',
      },
    },
    searchInput: 'Pesquisar...',
    newWhatsAppBroadcastButton: 'Nova lista de transmissão',
  },
  finishAttendanceConfirmationMessageTitle:
    'Você tem certeza que deseja finalizar esse atendimento?',
  newContactBadgeTitle: 'NOVO',
  previewImage: {
    titleDragDrop: 'Arraste arquivos para cá para enviar',
    subTitleDragDrop:
      'Ou pressione ctrl+v para fazer upload da sua área de transferência',
    subTitle2DragDrop: 'Arquivos até 5MB',
  },
  ackCallRequest: {
    browserNotification: {
      newCallTitle: 'Chamada recebida',
      contactNotFound: '{phoneNumber}',
      contactFound: '{contactFullname}\n{phoneNumber}',
      multipleContactFound: '{phoneNumber}',
      transferRequestTitle: 'Solicitação de transferência',
      transferRequestSubtitle: 'De: {agentName} ({agentId})',
    },
    appNotification: {
      multipleContactFound: 'Mais de um contato encontrado',
      contactNotFound: 'Contato não cadastrado',
      title: 'Chamada recebida',
      acceptButton: 'Aceitar',
      rejectButton: 'Recusar',
      callReceived: 'Chamada recebida. Telefone: {phoneNumber}',
      callAccepted: 'Chamada aceita. Telefone: {phoneNumber}',
      callDeclined: 'Chamada recusada. Telefone: {phoneNumber}',
      callLost:
        'Chamada perdida: O cliente com o telefone {phoneNumber} desligou a ligação antes de ser atendido.',
    },
    volume: 'Toque de atendimento',
  },
  image: 'Imagem',
  document: 'Documento',
  emoji: 'Emoji',
  updateAgentsAvailableButton: 'Atualizar lista de agentes disponíveis',
  attendanceGroupsUnavailableByAgent: 'Nenhum grupo encontrado',
  attendanceGroupsUnavailable: 'Nenhum grupo encontrado',
  webRTC: {
    dialpad: {
      ackCallRequestRejectCall:
        '[ACKCALLREQUEST (Chamada Recusada) - Enviado DTMF *]',
      ackCallRequestAcceptCall:
        '[ACKCALLREQUEST (Chamada Aceita)- Enviado DTMF #]',
      sendDigit: '[DIALPAD - Enviado DTMF {digit}]',
    },
  },
  connection: {
    tryingReconnectTitle: 'Ops! Perdemos a conexão. ',
    reconnectedTitle: 'Conexão reestabelecida',
    recoverJobs:
      'A conexão foi reestabelecida, mas precisaremos reiniciar os atendimentos que estavam em progresso.',
    reconnected: 'Reestabelecendo conexão...',
    recoverJobsQuestion: 'Deseja restaurar seus atendimentos agora?',
    lostConnection:
      'Por favor, verifique sua internet e aguarde um momento. Assim que estiver de volta, conectaremos automaticamente.',
    buttonNo: 'Não',
    buttonYes: 'Sim',
    voiceProblem: 'Houve um problema ao conectar o canal de voz',
    voiceProblemTitle: 'Não foi possível realizar a conexão de voz.',
    voiceProblemDescription:
      'Certifique-se que você está com o microfone ativo e com permissão habilitada no browser. Deseja se reconectar ao canal de voz?',
    buttonReconnect: 'Reconectar',
    buttonCancel: 'Cancelar',
  },
  contactSearch: {
    identifier: 'ID',
    name: 'Nome do contato',
    phone: 'Telefone',
    whatsApp: 'WhatsApp',
    instagram: 'Instagram',
    employerAndRole: 'Cargo e empresa',
    whatsAppVoiceSessionStatus: 'Sessão de WhatsApp(Voz)',
  },
  employer: 'Empresa',
  employerCard: {
    employerTitle: 'Empresa',
    employerTooltip: 'Empresa',
    employerCnpjTooltip: 'CNPJ',
    employerCodeTooltip: 'ID empresa',
    employerRoleTooltip: 'Cargo',
    emptyInformation: 'Não informado',
  },
  contactManagement: {
    myContactsTab: 'Contatos',
    employerTab: 'Empresas',
    myContactsPage: {
      title: 'Contatos',
      subtitle:
        'Veja aqui os contatos que estão fidelizados com você. Os contatos podem ser fidelizados utilizando o campo agente responsável do cadastro do contato ou alimentado por um mailing através do supervisor.',
      addContactButton: 'Novo contato',
      filter: 'Filtrar',
      tableFooterShowing: 'Mostrando',
      tableFooterOf: 'de',
      tableFooterItems: 'registros',
      tableHeaderId: 'ID',
      tableHeaderName: 'Nome do contato',
      tableHeaderPhone: 'Telefone',
      tableHeaderWhatsApp: 'WhatsApp',
      tableHeaderInstagram: 'Instagram',
      tableHeaderRoleAndEmployer: 'Cargo e Empresa',
      tableHeaderEmployerRole: 'Cargo',
      tableHeaderChurnBusterRisk: 'Risco de churn',
      tableHeaderContactTags: 'Tags',
      tableHeaderEmployerTags: 'Tags',
      tableHeaderWhatsAppVoiceSessionStatus: 'Sessão de WhatsApp(Voz)',
    },
    employerPage: {
      title: 'Empresas',
      subtitle:
        'Veja aqui as empresas cadastradas no sistema. Você pode a qualquer momento editar as informações, complementar e adicionar novos cargos, além de associa-las aos contatos do sistema.',
      addEmployerButton: 'Nova empresa',
      tableFooterShowing: 'Mostrando',
      tableFooterOf: 'de',
      tableFooterItems: 'registros',
      tableHeaderEmployerCode: 'ID',
      tableHeaderEmployerName: 'Empresa',
      tableHeaderEmployerCnpj: 'CNPJ',
      tableHeaderEmployerRoles: 'Cargo',
    },
    employerForm: {
      employerNameDuplicated: 'Nome de empresa já registrado no sistema.',
      employerCodeDuplicated: 'ID da empresa já existe.',
      employerCnpjDuplicated: 'O CNPJ já está registrado com outra empresa.',
      employerSocialNameDuplicated:
        'Razão social já está sendo utilizada por outra empresa.',
      employerCreateSuccess: 'Empresa criada com sucesso!',
      employerUpdateSuccess: 'Empresa atualizada com sucesso!',
      employerCreateError: 'Houve um problema ao cria a empresa.',
      employerUpdateError: 'Houve um problema ao atualizar a empresa.',
    },
  },
  contactEmployerFields: {
    employerName: 'Nome da empresa',
    employerSocialName: 'Razão Social',
    employerCode: 'ID empresa',
    employerRole: 'Cargo',
    employerCnpj: 'CNPJ',
  },
  contactEmployerDialog: {
    addNewEmployerTitle: 'Nova empresa',
    editNewEmployerTitle: 'Editar empresa',
    employerName: 'Nome empresa*',
    employerSocialName: 'Razão Social',
    employerCode: 'ID empresa*',
    employerCnpj: 'CNPJ',
    buttonReturn: 'Voltar',
    buttonAdd: 'Adicionar',
    buttonUpdate: 'Atualizar',
    employerNameRequired: 'Nome da empresa é obrigatório.',
    employerCodeRequired: 'ID da empresa é obrigatório.',
    invalidCnpjFormat: 'Formato de CNPJ inválido.',
    employerNameMaxLength: 'Nome da empresa deve ser menor que 200 caracteres.',
    employerSocialNameMaxLength:
      'Nome social da empresa deve ser menor que 200 caracteres.',
    employerCodeMaxLength: 'ID da empresa deve ser menor que 18 caracteres.',
    employerRoleNameMaxLength: 'Cargo deve ser menor que 100 caracteres.',
  },
  employerCodeDuplicated: 'ID já existe.',
  fastJobDialog: {
    fastJobTitle: 'Acionamento rápido',
    fastJobBy: 'Acionar contato via',
    noDataText: {
      campaignSelected: 'Você não está vinculado a nenhum grupo',
    },
    errors: {
      phoneNumber: 'Digite um número válido',
      campaignSelected: 'É necessário selecionar um grupo',
    },
    channels: {
      voice: 'Telefone',
      whatsapp: 'Whatsapp',
    },
    buttons: {
      trigger: 'acionar',
    },
  },
  version: 'Versão',
  passwordPage: {
    createNewPasswordTitle: 'Crie uma nova senha',
    createNewPassewordSubtitle: 'Defina uma nova senha para acessar o WeON.',
    updatePassword: 'Atualizar senha',
    resetSuccess: 'Sua senha foi redefinida com sucesso!',
    returnToLoginButton: 'Voltar para o login',
    minLengthError: 'Senha deve ter no mínimo 8 caracteres',
    maxLengthError: 'Senha deve ter no máximo 15 caracteres',
    passwordsNotMatch: 'Senhas não conferem',
  },
  download: 'Download',
  loading: 'Carregando...',
  callsBetweenAgentsNotAllowed: 'Ligação entre agentes não permitida.',
  agentVoiceDisconnected: 'Você está desconectado do canal de voz.',
  contact: 'Contato',
  pickpocketing: 'Carteirização',
  responsibleAgent: 'Agente responsável',
  messageRegisteredSuccess: '{name} cadastrado com sucesso!',
  messageContactInformationError:
    'Ocorreu um erro ao recuperar os dados do contato',
  messageUpdateContact: 'Contato editado com sucesso!',
  messageAddTagSuccess: 'Tag adicionada com sucesso!',
  messageErrorWhatsapp: 'Sem WhatsApp cadastrado',
  messageErrorPhone: 'Sem telefone cadastrado',
  navigationBar: {
    attendanceModule: {
      attendances: 'Atendimento',
      email: 'E-mail',
    },
    featureModule: {
      history: 'Histórico',
      dashboard: 'Dashboard',
      broadcast: 'Transmissão',
      contacts: 'Contatos',
      employer: 'Empresas',
      colleagues: 'Colegas',
    },
  },
  colleagues: {
    title: 'Colegas',
    search: 'Pesquisar',
    filter: 'Filtrar',
    nodata: {
      title: 'Nenhum colega encontrado',
      empty: 'No momento sua lista de colegas se encontra vazia',
      notFound:
        'Mude os termos da busca ou altere os filtros selecionados para encontrar um resultado',
    },
    callRequest: {
      cancel: 'cancelar',
      answer: 'atender',
      tryAgain: 'Tentar de novo',
      reject: 'Recusar',
    },
    callInProgress: {
      title: 'Chamada Interna',
      hangupCall: 'Desligar chamada',
    },
    hangupCallDtmf: '[COLLEAGUES-DTMF] - Hangup acionado via DTMF',
  },
  organia: {
    churnBusterStatus: {
      noChurn: 'Sem risco',
      lowestChurn: 'Muito baixo',
      lowChurn: 'Baixo',
      mediumChurn: 'Médio',
      highChurn: 'Alto',
      highestChurn: 'Muito alto',
    },
    churnBusterCard: {
      title: 'Risco identificado',
      subtitle:
        'O risco de churn é o risco de que o cliente seja desligado do atendimento por um período de tempo prolongado.',
      checkDetails: 'Ver detalhes',
      noChurn: 'Sem risco',
      noChurnDetected:
        'A OrganIA analisou este contato e não foi identificado risco de churn.',
    },
    churnBusterDialog: {
      openExternalUrl: 'Abrir uma página externa',
      openExternalUrlRedirect: 'Você será direcionado para uma página externa.',
      openExternalUrlButton: 'Continuar',
      dontAskAgainCheckbox: 'Não exibir esta mensagem novamente.',
    },
    churnBusterOverall: {
      risk: 'Risco',
      contactInformationTooltip:
        'O risco de churn herda o risco do atendimento mais crítico dentre as análises realizadas pela IA desde a última remoção de risco.',
      contactInformationTooltipEmployer:
        'Se um ou mais contatos cadastrados nesta empresa apresentarem riscos diferentes, a empresa herdará o risco do contato mais crítico.\nPara remover o risco da Empresa, resolva os riscos dos contatos associados a ela.',
      totalAnalysis: 'Total de atendimentos',
    },
    churnBusterJustificationDialog: {
      removeRisk: 'Remover o risco',
      justification: 'Justificativa',
      justificationLabel: 'O que foi feito para remover o risco desse contato?',
      minSizeHint: 'Mínimo de 50 caracteres',
      cancelButton: 'Cancelar',
      removeRiskButton: 'Remover risco',
      openExternalUrlButton: 'Continuar',
      dontAskAgainCheckbox: 'Não exibir esta mensagem novamente.',
      removeChurnRiskSuccess: 'Risco removido com sucesso',
      removeChurnRiskError: 'Houve um problema ao remover o risco.',
    },
    agentAbsent: {
      agentAbsentDialogTitle:
        'Um supervisor adicionou você como ausente temporariamente.',
      agentAbsentDialogCheckbox: 'Confirmar retorno',
      agentAbsentDialogSubtitle:
        'Neste status, você pode navegar pelo sistema mas não receberá novos atendimentos.',
      agentAbsentDialogHeader: 'Você está ausente',
      agentAbsentStayAwayButton: 'Permanecer Ausente',
      agentAbsentConfirmButton: 'Continuar',
      agentAbsentAgentInformationButton: 'Ausência',
    },
  },
  agentAbsent: {
    agentAbsentDialogTitle:
      'Um supervisor adicionou você como ausente temporariamente.',
    agentAbsentDialogCheckbox: 'Confirmar retorno',
    agentAbsentDialogSubtitle:
      'Neste status, você pode navegar pelo sistema mas não receberá novos atendimentos.',
    agentAbsentDialogHeader: 'Você está ausente',
    agentAbsentStayAwayButton: 'Permanecer Ausente',
    agentAbsentConfirmButton: 'Continuar',
    agentAbsentAgentInformationButton: 'Ausência',
  },
  DialogConversation: {
    body: {
      noMessages: 'Nenhuma mensagem trocada',
      loading: 'Carregando mensagens...',
    },
    header: {
      newContact: 'NOVO',
      messagesCount: 'Mensagens',
      finished: 'Finalizado',
      search: {
        placeholder: 'Pesquisar nas mensagens...',
      },
      viewProfile: 'Ver perfil',
    },
    footer: {
      agent: 'Agente',
      attendanceGroup: 'Grupo de atendimento',
    },
    download: {
      button: 'Baixar conversa',
      loading: 'Gerando PDF...',
      title: 'Dados do atendimento',
      subtitle: 'Histórico de conversas',
      error: 'Erro ao gerar PDF',
    },
  },
  qualifiedAttendanceEndJobMessage:
    'O atendimento de {channel}, protocolo {protocol}, foi finalizado por tempo esgotado de qualificação.',
  forwardMessage: {
    title: 'Encaminhar mensagens para',
    jobs: 'Atendimentos recentes',
    emptyStateTitle: 'Sem atendimentos disponíveis',
    emptyStateSubtitle:
      'Verifique se o atendimento está aberto ou se ele esta retido. Voce pode buscar por telefone, nome ou protocolo.',
  },
  headerAttendance: {
    whatsappVoiceCallTooltip: 'Realizar chamada de voz por whatsapp',
  },
};
